/**
 * Angular imports.
 */
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FileUploadKeeperService } from 'src/app/dataservices/file-upload-keeper.service';
/**
 * Service imports.
 */
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DqVideoPlayerService } from 'src/app/dataservices/dqVideoPlayer/dq-video-player.service';
import { GetService } from 'src/app/dataservices/get.service';
import { UserStoryService } from 'src/app/dataservices/userStory/user-story.service';
import { AuthService } from '../../auth/auth.service';
import { EncryptionService } from '../../auth/encryption.service';
import { LocalstorageService } from '../../auth/localstorage.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FileUploadService } from '../../dataservices/file-upload.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { UploadfileWithForkService } from '../../dataservices/uploadfile-with-fork.service';
import { PostwebService } from '../../dataservices/web/postweb.service';

/**
 * Animation imports.
 */
import { animationI, animationII, animationIV } from '../../animations/utility.animation';

/**
 * Directive imports.
 */
import { ButtonDirective } from '../../directives/ga.directive';

/**
 * Library imports.
 */
import { CarouselComponent, OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { IPageInfo } from 'ngx-virtual-scroller';

/**
 * Constant import.
 */
import { ACTION_ON, ACTION_TYPE, CAROUSEL, CONNECTION_STATUS, CREATE_STORY_TYPES, CTA_TYPE, CTA_TYPE_ACTION, EXPLORE_SECTION, FEED_KIND, GRADIENT_DIRECTION, GR_FILTER, HCF_CONNECTION_ID, NCP_PRODUCT_SUBTYPE, NO_INFO_TYPE, NUMBERS, POST_SCREEN, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME, SPLIT, STORY_CREATION_TYPE, STORY_DEFAULT_DURATION, STORY_LOADING_STATE, STORY_TYPES, TEMPLATE_TYPE, USER_STORY_NUDGE } from '../../constants/app.constants';
import { EVENT_NAME } from './../../analytics-event/analytics.constant';

/**
 * Import interface.
 */
import { UserStoryList } from 'src/app/interface/user-story/user-story';
import { AnalyticsInterface, EventDataKey } from '../../analytics-event/analytics.model';
import { ChannelInfo } from '../../interface/channel/channel';
import { EventTrackerConfig } from '../../interface/event/event';
import { Profile, UserProfileRoot } from '../../interface/userprofile/userprofile';
import { CardRendering, CommunityList, FilterList, MyCommunityList, Target, promoStrip } from '../../onboarding/interface/global.model';
import { ENTRY, EXIT, extra, HOME_ENTRY, HOME_EXIT, LIST_ENTRY, LIST_EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * Rxjs imports.
 */
import { BehaviorSubject, Subscription, fromEvent, of } from 'rxjs';
import { debounceTime, delay, tap } from 'rxjs/operators';

/**
 * Service imports.
 */
import { AnalyticsEventService } from './../../analytics-event/analytics-event.service';
import { DocquityAnalyticsService } from './../../dataservices/docquity-analytics/docquity-analytics.service';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

/**
 * Feed List Component
 */
@Component({
  selector: 'app-feed-list',
  templateUrl: './feed-list.component.html',
  styleUrls: ['./feed-list.component.scss'],
  animations: [animationI, animationII, animationIV],
})
export class FeedListComponent implements OnInit, AfterViewInit, OnDestroy  {

  /**
   * @pOffset holds current item index
   */
  @Input() pOffset: number;
  /**
   * Key pair value to store the productTypeId of cards.
   */

  private renderingCards: CardRendering[] = [];
  /**
   * Scroll flag change when scroll is stop.
   */
  private scroll = false;

  /**
   * Screen names for the rendering screen.
   */
  private screenName = SCREEN_NAME;

  /**
   * play time for hcf continue watch
   */
  public playTime: string;
  /**
   * to store promo strip content
   */
  public pvsData: promoStrip;
  /**
   * to store promo view strip html
   */
  public pvsHtml: SafeHtml;
  /**
   * flag to render pvs
   */
  public render = false;
  /**
   * pps flag
   */
  public pvsFlag: boolean;
  public isStoryIntroViewed =  new BehaviorSubject(false);
  /**
   * story intro flag
   */
  public isStoryIntroEnabled: boolean;

  /**
   * story tutorial paragraph text
   */
  public storyIntroParagraphText: string;
  /**
   * story tutorial steps
   */
  public storyTutorialStep = 0;

  /**
   *primary button text for story intro
   */
  public primaryButtonTextIntro = '';

  /**
   * public secondary button text
   */
  public secondaryButtonTextIntro = 'Learn More';

  /**
   * start time
   */
  private feedFilterStartTime = 0;

  /**
   * Spilt symbol for the product type and id.
   */
  private splitProductTypeId = SPLIT;
  public randomSize = false;
  public userctivity = false;
  protected loading: boolean;
  public shouldPrependItems = false;
  public timer;
  public page_from = this.mls.googleEventText.grandround.category;
  public publicTranslations = {
    key1: this.mls.languageText.community.key71,
    key2: this.mls.languageText.community.key10
  };
  @ViewChild('owlItem', { static: false }) owlItem: any;
  @ViewChild('owlCarousel') owlCarousel: CarouselComponent;
  public customOptionsForStories: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    center: true,
    navSpeed: 700,
    smartSpeed: 250000,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      600: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
    autoHeight: true
  };
  public customOptionsForStoriesList: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    center: false,
    navSpeed: 90,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 3,
        navSpeed: 900
      },
      400: {
        items: 3,
        navSpeed: 900
      },
      600: {
        items: 3
      },
      940: {
        items: 3
      }
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
    autoHeight: true,
    autoWidth: true
  };
  public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      600: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
    autoHeight: true
  };
  public sliderwebinarOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      600: {
        items: 2
      },
      940: {
        items: 2
      }
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
  };
  public hcfOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 1.15
      },
      420: {
        items: 1.5
      },
      600: {
        items: 1.5
      },
      940: {
        items: 1.5
      }
    },
    nav: true,
    margin: 14,
    autoplay: false,
    autoWidth: true
  };
  public storyIntroImage = ['assets/images/story-tutorial-1.svg', 'assets/images/story-tutorial-2.svg', 'assets/images/story-tutorial-3.svg'];
  public hcfContinueWatchOpt: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    items: 5,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 2
      },
      400: {
        items: 2.7
      },
      600: {
        items: 2.7
      },
      940: {
        items: 2.7
      }
    },
    nav: true,
    margin: 14,
    autoplay: false,
    autoWidth: true
  };cskks: any[];
  elem: HTMLElement;
  public userStoryCurrentTime: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public flags: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public offset: any = 1;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feedMixListData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feedMixList: any = [];
  public finished = false;
  public finishedFilter = false;
  public userProfileData: UserProfileRoot;
  public user_profile: Profile;
  public isErrorModalShown = false;
  public error_msg: string;
  public loginUserCustomeId: string;
  public Channel_info: ChannelInfo;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public profileObj: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public verificationData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feedFilter: any = '';


  public grStartTime: number;
  public screen_name = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public isDisabled: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public isMobile: any;
  public deviceInfo = null;
  public hit_list_api = false;
  public scroll_position = 0;
  public flag = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public deviceType: any;
  public uploadCompleted = false; // for show msg when post successfull
  public fileUploading = false;
  public currentUploadingFile = '';
  public journal_clicked = 'journal_clicked';
  public sessiontime = { 'start_time': '', 'end_time': '' };
  public tooltip_data = [];

  /**
   * Screen name.
   */
  public callingfrom = SCREEN_NAME.GRAND_ROUND;

  /**
   * Show view all channel key.
   */
  public showViewAllDrug = false;

  /**
   * Selected drug Index.
   */
  public drugIndex = 0;

  /**
   * Therapeutic filter list.
   */
  public therapeuticFilterList: FilterList[];

  /**
   * Drug list data.
   */
  public drugListData = [];

  /**
   * Store title and etpmId.
   */
  public drugSpeciality: { title: string, etpm_id: string };

  /**
   * Drug view all offset.
   */
  public drugViewAllOffset = 1;

  /**
   * Subscribe/Unsubscribe therapeutic list.
   */
  public therapeuticListSubscription: Subscription;

  /**
   * Subscribe/Unsubscribe drug list.
   */
  public drugListSubscription: Subscription;

  /**
   * View all drug list loader key.
   */
  public viewAllDrugLoader = false;
  /**
   * screen name for grandround.
   */
  public callFrom = CAROUSEL.GRANDROUND;
  /**
   * Type for carousal
   */
  public type = CAROUSEL.TYPE;
  /**
   * Type for my community carousel
   */
  public myCommunityCarousel = '';

  /**
   * Contains list of ncp subtypes except healthCard
   */
  readonly ncpSubtypes: string[] = [
    NCP_PRODUCT_SUBTYPE.ACADEMY,
    NCP_PRODUCT_SUBTYPE.CHALLENGES,
    NCP_PRODUCT_SUBTYPE.GAMES,
    NCP_PRODUCT_SUBTYPE.PAP_LISTING
  ];

  /**
   * Drug nudge specility carousel property.
   */
  public customOptionsNudge: OwlOptions = {
    loop: false,
    touchDrag: true,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    margin: 10,
    autoWidth: true,
    items: 5,
    dots: false,
    nav: true,
    responsive: {
      0: {
        items: 1.85
      },
      310: {
        items: 2
      },
      340: {
        items: 2.15
      },
      450: {
        items: 2.8
      },
      470: {
        items: 3
      }
    }
  };

  /**
   * Key used to store selected specialty name.
   */
  public selectedSpecialty: string;

  /**
   * Key used to show filtered data information.
   */
  public filterDataInfo = false;

  /**
   * Key used to store id of feed specialty.
   */
  public feedId: number;

  /**
   * Key used to subscription of specialty.
   */
  private specialtySubs: Subscription;

  /**
   * Tag filter applied from GR or Not.
   */
  public grHashTagFilters: boolean;

  /**
   * Analyticsdata object.
   */
  public analyticsData: AnalyticsInterface;
  /**
   * Analyticsdata object for connection view all click.
   */
  public analyticsConnectionViewAll: AnalyticsInterface;
  /**
   * Product type constants.
   */
  public productType = PRODUCT_TYPE_CONSTANT;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * Check the status of post button.
   */
  public isPostButtonDisable = false;

  public eventName = EVENT_NAME;

  /**
   * Import numbers from constant.
   */
  public numbers = NUMBERS;

  /**
   *
   * Gradient direction constant
   */
  public gradientDirection = GRADIENT_DIRECTION;

  /**
   * Flag to track scroll event
   */
  private scrollEventTriggered = false;

  /**
   * NCP Product subtype
   */
  public ncpProductSubType = NCP_PRODUCT_SUBTYPE;

  /**
  * screen name for ec card
  */
  public ecScreenName = SCREEN_NAME.GRAND_ROUND;

  /**
  * constant for Explorer section
  */
  private exploreSection = EXPLORE_SECTION;

  public channelAnalyticsData: EventTrackerConfig;

  /**
   * contains public community list
   */
  private communityList: CommunityList;
  /**
   * For storing product type of carousal card
   */
  public productTypeCarousal = PRODUCT_TYPE_CONSTANT.OTHER_CARD;
  public isStoriesOpen = false;
  public storyListing: any;

  public prevOffset: number;

  public storyListEnd = false;

  /**
   * to store whole story list
   */
public userStoryList: UserStoryList[] = [];
  /**
   * story list offset
   */
  public storyListOffset = 1 ;
  public isStoryCreation = false;

  /**
   * No story type constant.
   * 0 for the whole stories list
   * 1 for the story view detail
   * 2 for the story thumbnail.
   */
  public NO_STORIES_TYPE = NO_INFO_TYPE;

  /**
   * current story index
   */
  public activeStoryIndex = 0;

  /**
   * sub index of the story
   */
  public activeIndex = 0;

  naming = 'start';

  /**
   * hcf product type id
   */
  public hcfproductTypeId = HCF_CONNECTION_ID;

  /**
   * story intro center image
   */
  public storyIntroCenterImage: string;


  /**
   * contains public community list
   */
  private myCommunity: MyCommunityList;

  /**
   * HCF connection suggestion connect button label.
  */
  public hcfConnectionLabel = this.mls.languageText.connection_card.key9;


  /**
   * Necessary instance.
   */
  constructor(
    @Inject(DOCUMENT) private document: any,
    private deviceService: DeviceDetectorService,
    public funCollectionService: FunCollectionService,
    private postwebService: PostwebService,
    private localStorage: LocalstorageService,
    private authService: AuthService,
    private masterService: MasterserviceService,
    public mls: NewLanguageService,
    public route: ActivatedRoute,
    public dss: DataStorageService,
    private fileus: FileUploadService,
    private postSer: PostApiService,
    public igs: ImageGroupService,
    private gerSer: GetService,
    private jwtSer: JwtDecodeService,
    private http: HttpClient,
    private fileUsFork: UploadfileWithForkService,
    public router: Router,
    private encrypt: EncryptionService,
    private analyticsEventService: AnalyticsEventService,
    private dqVideoPlayerService: DqVideoPlayerService,
    public userStorySer: UserStoryService,
    public changeDetectorRef: ChangeDetectorRef,
    private fileUpload: FileUploadKeeperService,
    private domSanitize: DomSanitizer,
    private docquityAnalytics : DocquityAnalyticsService,
    private analyticSdk: Analytics
  ) {
    // negm
    route.queryParams.subscribe(p => {
      if (p.storySafeUrl != undefined) {
        this.dss.viewStoryThroughNotificationUuid = p.storySafeUrl;
        this.dss.currentStoryCode = p.storyCode;
        this.dss.viewListByDefault = p.viewerList;
        this.dss.showStoryThroughNotification.next(true);
      }
      if(p?.grfilter) {
        this.feedListLoad();
      }
    });

    this.subscriptions.add(this.route.params.subscribe(data => {
      if (data.id == 276) {
        this.feedFilter = [{ 'key': 'channel', 'value': [276] }];
        this.getFeedList(this.offset);
      }
      if (data.detailId != undefined) {
        const x = { is_show: true, feed_id: data.detailId, mediaIdx: 0 };
        this.dss.showFeedDetailInModal.next(x);
      }
      if (data.storySafeUrl !=undefined && data.storyCode != undefined) {
        // no code
      }
    }));

    // for remove back button from header
    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();

    if (sessionStorage.getItem('loginuserProfileData') != null) {
      const xprofiledata = (JSON.parse(this.encrypt.decryptAes(this.localStorage.getInSessionStorage('loginuserProfileData'))));
      if (xprofiledata.permission == 'readonly') {
        this.verificationData = xprofiledata.permission;
      }
    }

    // updated edited feed object
    this.subscriptions.add(this.dss.edited_feed_obj.subscribe(data => {
      this.feedMixList[data.feed_index].products[0] = data.data;
      this.fileUploading = false;
      this.uploadCompleted = true;
    }));

    this.subscriptions.add(this.fileus.new_feed_post_added.subscribe(data => {
      this.fileUploading = false;
      this.uploadCompleted = true;
      const t = this.feedMixList.findIndex(obj => obj.product_type == 31);
      if (t != -1) {
        // this.feedMixList.insert(t, data);
        this.feedMixList.splice(t + 1, 0, data);
      } else {
        this.feedMixList.unshift(data);
      }
      this.subscriptions.add(of(true).pipe(
        delay(0),
        tap(() => {
          this.callCardRecord();
        })).subscribe());
    }));



    this.subscriptions.add(this.postwebService.getFeedAdded().subscribe(data => {
      // this.jwtSer.decodeData(resData).then(data=>{
      if (data === true) {
        this.feedMixList = [];
        this.offset = 1;
        this.feedListLoad();
        this.finished = false;
        this.postwebService.setFeedAdded(false);
      }
    }));

    this.screen_name = this.route.snapshot.data['screen_name'];
    this.isDisabled = this.funCollectionService.epicFunction();


  }
  /**
   * get user story list
   */
  async getUserStoryList(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      this.subscriptions.add(await this.gerSer.getUserStoryList('1',this.storyListOffset).subscribe(data => {
        if (data?.lc) {
              this.userStoryList = this.userStoryList.concat(data.lc);
              this.userStorySer.storyThumbnail.push(...data.lc);
              this.userStorySer.mapFileCodeWithUrl(data.lc, 'carouselCode');
              this.storyListOffset++;
              resolve();
        }
        else if (data?.status === 204) {
         this.storyListOffset = 0;
         this.storyListEnd = true;
         reject();
        } else {
          this.storyListOffset = 0;
        }
      }));
      this.subscriptions.add(this.userStorySer.storyDataChanged.subscribe(data => {
       this.changeDetectorRef.markForCheck();
       this.changeDetectorRef.detectChanges();
      }));
    });
  }
  /**
   * get carousel id
   */
  getCarouselId(id): string {
    return id.toString();
  }

  /**
   * function to load first type stories list
   */
  public async getStoryCarouselList(): Promise<void> {
    await this.getUserStoryList().then(res => {
      if (this.userStoryList.length < 8 && this.storyListOffset !== 0) {
        this.getStoryCarouselList();
        this.subscriptions.add(this.dss.isStoryTutorialEnabled.subscribe(async data => {
          if (data === 1) {
            if (this.dss.profile_speciality?.length > 0 && this.userStoryList.length > 0) {
              await this.userStorySer.preloadImages(this.storyIntroImage);
              this.isStoryIntroEnabled = true;
            }
          }
          else if (data === 0) {
            this.isStoryIntroViewed.next(true);
          }
      }));
      }
    }).catch(error => {
      this.storyListEnd = true;
    });
  }
  /**
   * get carousel url and map it with
   */
  logStoryView(event): void {
    // no code
  }
  /**
   * log tutorial view
   */
  logTutorialView(key): void {
    this.subscriptions.add(this.postSer.logTutorialView(key).subscribe(data => {
      if (data) {
        //  no code
      }
    }));

  }

  /**
   * hide
   */
  onIntroHide(): void {
    this.isStoryIntroEnabled = false;
    this.logTutorialView(USER_STORY_NUDGE.story_tutorial);
    this.dss.isStoryTutorialEnabled.next(0);
    this.isStoryIntroViewed.next(true);
  }
  /**
   * get story intro text
   */
  getStoryIntroText(tutorialStep): void {
    // no code
  }
  /**
   * next tutorial event
   */
  nextStep(event): void {
    this.storyTutorialStep = event;
    if (this.storyTutorialStep === 0) {
      this.storyIntroParagraphText = this.mls.languageText.stories_tutorial.key25;
      this.storyIntroCenterImage = '';
      this.secondaryButtonTextIntro = this.mls.languageText.stories_tutorial.key20;
    }
    else if (this.storyTutorialStep === 1) {
      this.storyIntroParagraphText = this.mls.languageText.stories_tutorial.key27;
      this.storyIntroCenterImage = 'assets/images/story-tutorial-1.svg';
      this.primaryButtonTextIntro = this.mls.languageText.stories_tutorial.key22;
      this.secondaryButtonTextIntro = this.mls.languageText.stories_tutorial.key21;
    }
    else if (this.storyTutorialStep === 2) {
      this.storyIntroParagraphText = this.mls.languageText.stories_tutorial.key26;
      this.storyIntroCenterImage = 'assets/images/story-tutorial-2.svg';
      this.primaryButtonTextIntro = this.mls.languageText.stories_tutorial.key22;
      this.secondaryButtonTextIntro = this.mls.languageText.stories_tutorial.key21;
    }
    else if (this.storyTutorialStep === 3) {
      this.storyIntroParagraphText = this.mls.languageText.stories_tutorial.key28;
      this.storyIntroCenterImage = 'assets/images/story-tutorial-3.svg';
      this.primaryButtonTextIntro =  this.mls.languageText.stories_tutorial.key22;
      this.secondaryButtonTextIntro = this.mls.languageText.stories_tutorial.key23;
    }
    else if (this.storyTutorialStep > 3) {
      this.onIntroHide();
    }
  }
  /**
   * story change
   */
  onStoryChange(event): void {
    this.userStorySer.endAnimation.next(true);
  }
   isFullScreen: boolean;

  public canLoad = true;
  public pendingLoad = false;
  public busyGettingData = false;

  /**
   * eInit
   */
  ngOnInit(): void {
    setInterval( () => {
      this.canLoad = true;
      if ( this.pendingLoad ) {
        this.onScrollDown();
      }
    }, 2000);

    if (this.dss.isSpecialityOn != true && this.route.snapshot.queryParamMap.get('feed') != undefined) {
      if (this.funCollectionService.device_detail.is_desktop == false) {
        this.funCollectionService.navigateToFeedDetail(this.route.snapshot.queryParamMap.get('feed'));
      } else {
        const x = { is_show: true, feed_id: this.route.snapshot.queryParamMap.get('feed'), mediaIdx: 0, ecid: 0 };
        this.dss.showFeedDetailInModal.next(x);
      }
    }

    this.feedListLoad();
    this.initializeAnalyticsData();
    if(this.mls.featureOnOffList.featureList.pvs.value || !this.mls.userLoginFlow){
      this.getPromoViewStrip();
    }
    this.subscriptions.add(this.userStorySer.user_story_created.subscribe(data => {
      this.storyListOffset  = 1;
      this.userStorySer.storyThumbnail = [];
      this.userStoryList = [];
      this.customOptionsForStoriesList.startPosition = 0;
      this.getStoryCarouselList();
      this.funCollectionService.navigateToTop();
    }));
    this.subscriptions.add(this.dss.isStoryTutorialEnabled.subscribe(async data => {
        if (data === 1) {
          if (this.dss.profile_speciality?.length > 0) {
            await this.userStorySer.preloadImages(this.storyIntroImage);
            this.isStoryIntroEnabled = true;
          }
        }
        else if (data === 0) {
          this.isStoryIntroViewed.next(true);
        }
    }));
    this.subscriptions.add(this.isStoryIntroViewed.subscribe(data => {
      if (data === true) {
        if (this.dss.isStoryIntroductionEnabled === 1) {
          if (this.dss.user_profile_data.profile.permission == 'all') {
            this.generateStoryIntroNudge();
          }
        }
      }
    }));
    this.elem = document.documentElement;
    if (this.userStorySer.storyThumbnail.length > 0) {
      this.userStorySer.storyThumbnail = [];
      this.userStorySer.UserStoryDetail.clear;
    }
    if(this.mls.featureOnOffList.featureList.userStory.value || !this.mls.userLoginFlow){
    this.getStoryCarouselList();
  }
  }

  public onScrollDown():void {
    
    if(this.busyGettingData){
      
      return;
    }
    this.busyGettingData = true;
    this.onScroll();
  }


  /**
   * Initalizing analytics data
   */
  initializeAnalyticsData(): void {
    this.channelAnalyticsData = {
      category: this.mls.googleEventText.grandround.category,
      action: this.mls.googleEventText.grandround.key1,
      product_type: PRODUCT_TYPE_CONSTANT.CHANNEL.toString(),
      product_id: ''
    };
  }
  /**
   * feed List Load.
   */
  feedListLoad(): void {
    this.dss.global_selected_filter = 0;
    this.dss.search_keyword = '';

    this.dss.removechannelfilter();
    this.feedMixList = [];
    this.feedFilter = [];
    this.feedMixListData = [];
    this.feedFilter = this.dss.gr_filter;
    this.finishedFilter = true;

    this.applyGRFilter();



    this.specialtySubs = this.dss.specialty_tag.subscribe(specialty => {
      this.feedId = specialty.feed_id;
      this.selectedSpecialty = specialty.speciality_name || specialty.category_name ;
      const specialtyVal = [{ key: 'speciality', value: [specialty.speciality_id || specialty.category_id] }];
      this.dss.feed_filter.next(specialtyVal);
    });

    this.subscriptions.add(this.dss.feed_filter.subscribe(data => {
      this.feedMixList = [];
      if (data !== '') {
        if (data[0].key === 'speciality') {
          this.filterDataInfo = true;
        } else {
          this.filterDataInfo = false;
        }
        if (this.dss.currentGrFilter && this.dss.currentGrFilter?.length > 0) {
          const exitData: LIST_EXIT = {
            entity_type: this.dss.currentGrFilter[0]?.value[0] === GR_FILTER.EDITORS_CHOICE ? PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR : PRODUCT_TYPE_CONSTANT_NAME.FEED,
            entity_code: 0,
            current_screen_name:  this.dss.currentGrFilter[0]?.key == 'speciality' ?  'CONTENT_BY_SPECIALITY' : this.dss.currentGrFilter[0].value[0],
            start_time: this.feedFilterStartTime,
            end_time: new Date().getTime()
          }
          this.analyticSdk.analyticService.LIST_EXIT(exitData);
        }
        else {
          if (this.grStartTime > 0) {
            const exitData: HOME_EXIT = {
              entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
              entity_code: 0,
              current_screen_name: SCREEN_NAME.GRAND_ROUND,
              start_time: this.grStartTime,
              end_time: new Date().getTime()
            };
            this.analyticSdk.analyticService.HOME_EXIT(exitData);
            this.grStartTime = 0;
          }
        }
        this.feedFilter = (data == 'reset') ? [] : data;
        this.dss.currentGrFilter = (data == 'reset') ? [] : data;
        if (this.dss.currentGrFilter != 'reset' &&  this.dss.currentGrFilter && this.dss.currentGrFilter?.length > 0) {
          const entryData: LIST_ENTRY = {
            entity_type: this.dss.currentGrFilter[0]?.value[0] === GR_FILTER.EDITORS_CHOICE ? PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR : PRODUCT_TYPE_CONSTANT_NAME.FEED,
            entity_code: 0,
            source: this.funCollectionService.currentScreename ? this.funCollectionService.currentScreename : localStorage.getItem('triggerSource'),
            current_screen_name: this.dss.currentGrFilter[0]?.key == 'speciality' ? 'CONTENT_BY_SPECIALITY' : this.dss.currentGrFilter[0].value[0],
            start_time: this.feedFilterStartTime = new Date().getTime()
          };
          this.funCollectionService.currentScreename = this.dss.currentGrFilter[0]?.key == 'speciality' ? 'CONTENT_BY_SPECIALITY' : this.dss.currentGrFilter[0].value[0]
          this.feedFilterStartTime = new Date().getTime();
          setTimeout(() => {
            this.analyticSdk.analyticService.LIST_ENTRY(entryData);
          }, 100);
        }
        else {
          const grEntryData: HOME_ENTRY = {
            entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
            entity_code: 0,
            source: this.funCollectionService.currentScreename ?? localStorage.getItem('triggerSource'),
            current_screen_name: SCREEN_NAME.GRAND_ROUND,
            start_time: this.grStartTime = new Date().getTime()
          };
          this.funCollectionService.currentScreename = SCREEN_NAME.GRAND_ROUND;
          this.analyticSdk.analyticService.HOME_ENTRY(grEntryData);

        }
        this.ecScreenName = this.feedFilter.length && (this.feedFilter[0].key === 'properties') && this.feedFilter[0].value.includes(this.exploreSection.EDITORS_CHOICE) ? SCREEN_NAME.EDITOR_CHOICE_LIST : SCREEN_NAME.GRAND_ROUND;
        this.feedMixList = [];
        this.offset = 1;
        this.funCollectionService.navigateToTop();
        this.finishedFilter = true;
        this.getFeedList(this.offset);
        return;
      }
    }));

    this.subscriptions.add(this.fileUsFork.feed_post_in_process.subscribe(data => {
      this.userctivity = !this.userctivity;
      this.dss.feed_post_in_process.file_url = data.file_url;
      this.dss.feed_post_in_process.is_show = data.is_show;
      this.dss.feed_post_in_process.status = data.status;
    }));
    if (document.querySelector<HTMLElement>('#profile_show_hide')) {
      document.querySelector<HTMLElement>('#profile_show_hide').style.display = 'block';
    }

    if (this.feedMixList.length === 0 && this.dss.specialty_filter === '') {
      this.getFeedList(this.offset);
      this.flag = true;
    }

    if (this.dss.specialty_filter !== '') {
      this.selectedSpecialty =
        this.dss.specialty_filter.speciality_name
        || this.dss.specialty_filter.category_name
        || this.dss.specialty_filter.name
        || this.dss.specialty_filter.n;
      const specialtyVal =
        [{
          key: 'speciality',
          value: [
            this.dss.specialty_filter.speciality_id
            || this.dss.specialty_filter.category_id
            || this.dss.specialty_filter.id
            || this.dss.specialty_filter.specialty_id
            || this.dss.specialty_filter.code
          ]
        }];
      this.dss.feed_filter.next(specialtyVal);
    }

    this.loginUserCustomeId = this.authService.getbyName('profile_obj');

    // calling profile Api start
    this.subscriptions.add(this.masterService.getProfile()
      .subscribe(rootObject => {
        if (rootObject['status'] === 1) {
          this.masterService.profile_api_data.next(rootObject);
        }
      }));
    // calling profile Api end
    if (this.deviceService.isMobile() == true) {
      this.deviceType = 'mobile';
    } else if (this.deviceService.isTablet() == true) {
      this.deviceType = 'tablet';
    } else {
      this.deviceType = 'desktop';
    }
    //
    this.funCollectionService.IsUserActiveOnApp(this.page_from);
    this.subscriptions.add(this.dss.is_browser_tab_active_action.subscribe(data => {
      if (data.page_from == this.page_from && data.is_visible == 0) {
        // this.ngOnDestroy();
        const d = new Date();
        this.sessiontime.end_time = d.getTime().toString();

        // let d=new Date()
        // this.sessiontime.start_time=d.getTime().toString();
      } else if (data.page_from == this.page_from && data.is_visible == 1) {
        setTimeout(() => {
          const dd = new Date();
          this.sessiontime.start_time = dd.getTime().toString();
        }, 1000);
      }
    }));
    /**
     * Set false on component initialize time.
     */
    //
    this.grHashTagFilters = false;
    if (this.dss.currentGrFilter == undefined || this.dss.currentGrFilter.length == 0) {
      const entryData: HOME_ENTRY = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
        entity_code: 0,
        source: this.funCollectionService.currentScreename ?? localStorage.getItem('triggerSource'),
        current_screen_name: SCREEN_NAME.GRAND_ROUND,
        start_time: this.grStartTime = new Date().getTime()
      }
      this.funCollectionService.currentScreename = SCREEN_NAME.GRAND_ROUND;
      this.analyticSdk.analyticService.HOME_ENTRY(entryData);
    }
    /**
     * Set analyics object for connection view all click.
     */
    this.postDisableCheck();
  }

  /**
   * Get flag for enable and disable the post button.
   */
  postDisableCheck(): void {
    const checkDisableSub = this.postSer.getPostButtonStatus()
      .subscribe((res: boolean) => this.isPostButtonDisable = res);
    this.subscriptions.add(checkDisableSub);
  }

  /**
   * Host Listener
   */
  @HostListener('window:scroll', ['$event'])

  /**
   * on PageScroll
   */
  onPageScroll(): void {
    this.scroll_position = window.scrollY;
    if (this.scroll_position != 0) {
      this.masterService.scroll_position = this.scroll_position;
    }
  }

  /**
   * del Feed
   */
  delFeed(): void {
    this.isDisabled = this.funCollectionService.epicFunction();
  }

  /**
   * navigate To Connection
   */
  navigateToConnection(): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }

    this.funCollectionService.navigateToConnection();
  }

  /**
   * navigate To Channel
   */
  navigateToChannel(): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }

    this.funCollectionService.navigateToChannel();
  }

  /**
   * Feed specialty from feed post card.
   */
  feedListFilteredBySpecialty(specialty): void {
    this.selectedSpecialty =
      specialty.speciality_name || specialty.category_name;
    const specialtyVal =
      [{
        key: 'speciality',
        value: [specialty.speciality_id || specialty.category_id]
      }];
    this.dss.feed_filter.next(specialtyVal);
  }

  /**
   * Specialty tag of inner card of Editor's choice.
   */
  innerCardSelectedSpecialty(specialty): void {
    this.selectedSpecialty =
      specialty.speciality_name || specialty.category_name;
  }

  /**
   * get Feed List
   */
  getFeedList(offset): void {
    this.scrollEventTriggered = true;
    this.subscriptions.add(this.gerSer.grandRoundList(offset, this.feedFilter).subscribe(resData => {
      this.busyGettingData = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.finishedFilter = false;
          this.flag = false;
          this.feedMixListData = data;
          data.data.mix_list.forEach(list => {
            if (list.product_type === PRODUCT_TYPE_CONSTANT.OTHER_CARD) {
              if (list && list.products && list.products[0] && list.products[0].type === CAROUSEL.PUBLIC_COMMUNITY_CAROUSEL) {
                this.communityList = {
                  flags: { 'view_more': list.products[0].view_all },
                  list: list.products[0].cards,
                  label: list.products[0].heading_text,
                  sub_text: list.products[0].description_text,
                  key: CAROUSEL.PUBLIC_COMMUNITY_CAROUSEL
                };
                if (this.communityList.list.length < NUMBERS.TEN) { this.communityList.list.push(null); }
              }
            }
          });

          data.data.mix_list.forEach(list => {
            if (list.product_type === PRODUCT_TYPE_CONSTANT.OTHER_CARD) {
              if (list && list.products && list.products[0] && list.products[0].type === CAROUSEL.MY_COMMUNITY_CAROUSEL) {
                this.myCommunityCarousel = CAROUSEL.MY_COMMUNITY_CAROUSEL;
                this.myCommunity = {
                  flags: { 'view_more': list.products[0].view_all },
                  list: list.products[0].cards,
                  label: list.products[0].heading_text,
                  sub_text: list.products[0].description_text,
                  key: CAROUSEL.MY_COMMUNITY_CAROUSEL
                };
                if (this.myCommunity.list.length < NUMBERS.TEN) { this.myCommunity.list.push(null); }
              }
            }
          });

          if (this.feedMixListData.status === NUMBERS.ONE) {
            this.finished = true;
            this.scrollEventTriggered = false;
            if (this.offset == 1) {
              this.subscriptions.add(of(true).pipe(
                delay(0),
                tap(() => {
                  this.callCardRecord();
                })).subscribe());
            }
            this.offset = this.feedMixListData.data.offset;

            this.feedMixList = this.feedMixList.concat(this.feedMixListData.data.mix_list);

            const index = this.feedMixList.findIndex(grObject => (grObject.product_type === PRODUCT_TYPE_CONSTANT.FEED || grObject.product_type === PRODUCT_TYPE_CONSTANT.WEBINAR));
            if (index > NUMBERS.MINUS_ONE)
              this.feedMixList[index].products[0].showRepostTooltip = NUMBERS.ONE;

            if (this.offset == 1) {
              this.feedMixList = [];
            }
            this.flags = this.feedMixListData.data.flags;

          }
        } else if (data.status == 0) {
          this.funCollectionService.errorHandeler(data);
        }
      }, () => {
        this.finished = false;
      });
    }));
  }


  /**
   * Function used to go previous screen.
   */
  backToPrevious(): void {
    const prevRoute: string = this.funCollectionService.previousRoute;
    if (prevRoute !== '/web/list' && this.grHashTagFilters !== true) {
      this.router.navigateByUrl(prevRoute);
    } else {
      this.dss.feed_filter.next('reset');
      this.dss.specialty_filter = '';
    }
    if (prevRoute === '/login/otp?redirectUrl=%2Fweb%2Flist') {
      this.dss.feed_filter.next('reset');
      this.dss.specialty_filter = '';
    }
  }

  /**
   * Function used to identify where from the filter is applied.
   */
  grandroundFilters(): void {
    this.grHashTagFilters = true;
  }

  /**
   * on Scroll
   */
  onScroll(): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }
    if (this.offset > 1) {
      this.finished = false;
      if (!this.scrollEventTriggered) {
        this.getFeedList(this.offset);
      }
    }
  }

  /**
   * delete FeedIdx
   */
  deleteFeedIdx(feed_idx): void {
    this.subscriptions.add(this.postSer.deleteFeed(this.feedMixList[feed_idx].products[0].feed_id).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.feedMixList.splice(feed_idx, 1);
          this.funCollectionService.showSuccess(this.mls.languageText.grandround.key1, 'Success');
        } else if (data['status'] == 0) {
          this.funCollectionService.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * reset Error Modal
   */
  resetErrorModal(): void {
    this.isErrorModalShown = false;
  }

  /**
   * http Error Handeler
   */
  httpErrorHandeler(err): boolean {

    if (err.error.code == 2000) {
      this.ErrorHandler(err.error.error.msg);
      return false;
    } else if (err.error.error.code == 1002) {
      this.funCollectionService.logout();
    } else {
      this.ErrorHandler(err.error.error.msg);
      return false;
    }
  }

  /**
   * Error Handler
   */
  ErrorHandler(Err_msg): boolean {
    this.isErrorModalShown = true;
    this.error_msg = Err_msg;
    return false;
  }
  /**
   * get user story tutorial nudge
   */
  generateStoryIntroNudge(): void {
    const fullName = this.dss.user_profile_data.profile.first_name + ' ' +  this.dss.user_profile_data.profile.last_name;
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.STORY;
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.storyNudgeIcon = 'assets/images/wave-nudge.png';
    this.dss.storyNudgeHeading = this.mls.languageText.stories_tutorial.key14 + fullName;
    this.dss.storyNudgeDisc = this.mls.languageText.stories_tutorial.key15;
    this.dss.storyNudgeButton = this.mls.languageText.stories_tutorial.key30;
    this.dss.storyType = CREATE_STORY_TYPES.STORY;
    this.dss.StoryFileType = STORY_TYPES.IMAGE;
    this.dss.story_nudge_type = USER_STORY_NUDGE.is_story_introduction_enabled;
    this.dss.userStoryNudge.next(true);
  }

  /**
   * ngAfter View Init
   */
  ngAfterViewInit(): void {
    window.scrollTo(0, this.scroll_position);
    // tslint:disable-next-line: deprecation
    const loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
    console.log('Page load time is ' + loadTime);
    this.stopScrollEvent();
  }

  /**
   * reset Upload Complete
   */
  resetUploadComplete(): void {
    this.dss.post_process_obj = { file_url: '', status: '', is_show: false, progress_width: 0 };
    this.fileUsFork.feed_post_in_process.next(this.dss.post_process_obj);
  }

  /**
   * fetch More
   */
  public fetchMore(event: IPageInfo): void {
    if (this.shouldPrependItems && event.startIndex === 0) {
      this.fetchNextChunk();
    }
    if (!this.shouldPrependItems && event.endIndex === this.feedMixList.length - 1) {
      this.fetchNextChunk();
    }
  }

  /**
   * fetch Next Chunk
   */
  private fetchNextChunk(): void {
    this.loading = true;
    clearTimeout(this.timer);
    this.onScroll();
  }

  /**
   * Redirect user to drug detail.
   */
  viewDrugDetail(data): void {
    this.router.navigateByUrl('pharma/drug/' + data.drugInfo.drug_id);
  }

  /**
   * when user apply thereputic filter.
   */
  applyDrugCategory(index, data): void {
    if (data.therapeutic_drugs.length !== 0) {
      this.drugIndex = index;
      this.drugSpeciality = { title: data.title, etpm_id: String(data.etpm_id) };
    } else {
      this.drugSpeciality = { title: data.title, etpm_id: String(data.etpm_id) };
      this.viewAllDrugs(data, 1);
    }
  }

  /**
   * when user click on view all.
   */
  viewAllDrugs(data, type): void {
    this.drugViewAllOffset = 1;
    if (this.drugSpeciality === undefined || type === 0) {
      this.drugSpeciality = { title: data[0].title, etpm_id: String(data[0].etpm_id) };
    }
    const pharmaId = 0;
    const productTypeTheraputic = 10;
    const is_docrx = 1;
    this.therapeuticListSubscription = this.gerSer.getFilterList(pharmaId, productTypeTheraputic, is_docrx).subscribe(resData => {
      this.therapeuticFilterList = resData['data'].filter[0].list;
    });
    this.drugList();
    this.showViewAllDrug = true;
  }
  /**
   * Used to show all pharma list.
   */
  viewAllPharmas(): void {
    this.router.navigate(['/pharma/list']);
  }

  /**
   * Used to show Pharma details.
   */
  viewPharma(pharma): void {
    this.router.navigateByUrl('/pharma/detail/' + pharma.id);
  }

  /**
   * Function on select view all speciality.
   */
  applyViewAllSpeciality(speciality): void {
    this.drugSpeciality = { title: speciality.name, etpm_id: speciality.value };
    this.drugViewAllOffset = 1;
    this.drugListData = [];
    this.drugList();
  }

  /**
   * Drug list API call.
   */
  drugList(): void {
    const pharmaId = 0;
    this.viewAllDrugLoader = true;
    this.drugListSubscription = this.gerSer.getEDetailViewAllDrug(
      this.drugViewAllOffset, pharmaId, this.drugSpeciality.etpm_id).subscribe(resData => {
        this.viewAllDrugLoader = false;
        this.drugListData = this.drugListData.concat(resData['data'].therapeutic_drug_list);
        this.drugViewAllOffset = resData['data'].offset;
      });
  }

  /**
   * When user close drug modal.
   */
  backClicked(): void {
    this.showViewAllDrug = false;
  }

  /**
   * When user scroll drug list.
   */
  onScrolldrugs(): void {
    if (this.drugViewAllOffset > 1) {
      this.drugList();
    }
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy(): void {
    if (this.dss.currentGrFilter && this.dss.currentGrFilter?.length > 0) {
      const exitData: LIST_EXIT = {
        entity_type: this.dss.currentGrFilter[0]?.value[0] === 'editors_choice' ? PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR : PRODUCT_TYPE_CONSTANT_NAME.FEED,
        entity_code: 0,
        current_screen_name:  this.dss.currentGrFilter[0]?.key == 'speciality' ?  'CONTENT_BY_SPECIALITY' : this.dss.currentGrFilter[0].value[0],
        start_time:this.feedFilterStartTime,
        end_time: new Date().getTime()
      }
      this.analyticSdk.analyticService.LIST_EXIT(exitData);
    }
    else {
      if (this.grStartTime > 0 ) {
        const exitData: HOME_EXIT = {
          entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
          entity_code: 0,
          current_screen_name: this.funCollectionService.currentScreename,
          start_time: this.grStartTime,
          end_time: new Date().getTime()
        };
        this.analyticSdk.analyticService.HOME_EXIT(exitData);
      }
    }
    this.dss.currentGrFilter = [];
    this.userStorySer.UserStoryDetail.clear();
    this.userStorySer.storyThumbnail = [];
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.callCardRecord();
    const dateObject = new Date();
    this.sessiontime.end_time = dateObject.getTime().toString();
    this.funCollectionService.IsUserActiveOnApp('');

    if (this.therapeuticListSubscription) {
      this.therapeuticListSubscription.unsubscribe();
    }
    if (this.drugListSubscription) {
      this.drugListSubscription.unsubscribe();
    }
    if (this.specialtySubs) {
      this.specialtySubs.unsubscribe();
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * Collects all the appeared cards on the DOM view.
   */
  onCardAppear(cards): void {
    if(!sessionStorage.getItem('event_session_id')){
       this.funCollectionService.setSessionId();
    }
    this.renderingCards.push({
      local_id: this.funCollectionService.generateLocalId(),
      retry: false,
      track_id: this.dss.user_profile_data.profile.track_id,
      product_type: Number(cards.appearIds.split(this.splitProductTypeId)[0]),
      product_id: Number(cards.appearIds.split(this.splitProductTypeId)[1]),
      session_id: sessionStorage.getItem('event_session_id'),
      start_timestamp: cards.startTime,
      end_timestamp: cards.endTime,
      screen_name: this.screenName.GRAND_ROUND,
      scroll_type: cards.scroll_type
    });
  }

  /**
   * time after the last scroll event in ms after which the div should be visible again
   */
  stopScrollEvent(): void {
    const stopScrollSub = fromEvent(window, 'scroll')
      .pipe(tap(() => this.scroll = true), debounceTime(300))
      .subscribe(() => {
        this.callCardRecord();
        this.scroll = false;
      });
    this.subscriptions.add(stopScrollSub);
  }

  /**
   * Send collecting render cards.
   */
  callCardRecord(): void {
    this.funCollectionService.sendCardRecord(this.renderingCards);
    this.renderingCards = [];
  }

  /**
   * Get the appeared card product type and id.
   */
  getAppearedIds(card): string {
    if (card.product_type === PRODUCT_TYPE_CONSTANT.EDITORS_CHOICE) {
      return `${card.product_type}${this.splitProductTypeId}${card.products[0].product_type_id}`;
    }
    return `${card.product_type}${this.splitProductTypeId}${card.product_type_id ? card.product_type_id : card.product_id}`;
  }

  /**
   * Call the Custom XHR Api in case of window unload(reload, tab and browser close).
   */
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(): boolean {
    this.callXhrCardRenderingOnWindowUnLoad();
    return true;
  }

  /**
   * Call the onTabFocusOut function in case of tab focus out.
   */
  @HostListener('document:visibilitychange', ['$event'])
  visibilitychange(event): void {
    if (event.target.hidden) {
      this.onTabFocusOut();
    }
  }

  /**
   * Call the card rendering API in case of tab focus out.
   */
  onTabFocusOut(): void {
    this.subscriptions.add(of(true).pipe(
      delay(0),
      tap(() => {
        this.callCardRecord();
      })).subscribe());
  }

  /**
   * Call the Custom XHR Api in case of window unload(reload, tab and browser close).
   */
  callXhrCardRenderingOnWindowUnLoad(): void {
    if (!this.renderingCards) {
      return;
    }
    this.subscriptions.add(of(true).pipe(
      delay(0),
      tap(() => {
        this.postSer.cardRenderingOnWindowUnLoad(this.renderingCards);
        this.renderingCards = [];
      })).subscribe());
  }
  /**
   * For redirection to public community listing
   */
  navigateToCommunityList(): void {
    this.router.navigate(['community/list'], { queryParams: { view: CAROUSEL.VIEW_ALL } });
  }
  /**
   * For redirection to community detail
   */
  emitPublicCommunityDetail(communityId: string): void {
    this.funCollectionService.navigateToCommunityDetailPage(communityId);
  }
  /**
   * Receive params from url and apply filter.
   */
  applyGRFilter(): void {
    if (localStorage.getItem('verify_mobile')) {
      return;
    }
    const filter = this.funCollectionService.getParameterByName('grfilter');
    // eslint-disable-next-line no-prototype-builtins
    if (filter && GR_FILTER.hasOwnProperty(filter.toUpperCase())) {
      this.feedFilter = [{ 'key': 'properties', value: [filter.toLocaleLowerCase()] }];
      return;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (filter && POST_SCREEN.hasOwnProperty(filter.toUpperCase())) {
      this.dss.show_feed_post_modal.next(1);
      if (filter.toLocaleLowerCase() === POST_SCREEN.POLL_POST) {
        this.dss.posting_data.screen1.feed_kind = FEED_KIND.POLL;
      }
      return;
    }
  }

  /**
   * Necessary instances.
   */
  trackByFn(index: any, item: any): any {
    return item;
  }
  /**
   * check if there is any gr filter applied
   */
  checkForFilter(): boolean {
    if (this.feedFilter.length === 0) {
      return true;
    }
    return false;
  }
  onAllStoriesEnd(status: number): void {
    if (this.userStorySer.currentStoryIndex === this.userStorySer.storyThumbnail.length - 3 && this.storyListOffset !== 0) {
      this.checkForPrevOffset();
    }
    if (status || status == 1) {
      if (this.userStorySer.currentStoryIndex ===  this.userStorySer.storyThumbnail.length-1) {
        this.closeStories();
      }
      else {
        this.userStorySer.currentStoryIndex = this.userStorySer.currentStoryIndex + 1;
        this.userStorySer.currentStoryUuid = this.userStorySer.storyThumbnail[this.userStorySer.currentStoryIndex].uuid;
        this.activeStoryIndex =  this.activeStoryIndex + 1;
        this.storyStateManage(this.userStorySer.currentStoryUuid,this.activeStoryIndex, true );
      }
    }
    else {
      if (this.userStorySer.currentStoryIndex <= 0 ) {
        this.closeStories();
      }
      else {
        this.userStorySer.currentStoryIndex = this.userStorySer.currentStoryIndex - 1;
        this.activeStoryIndex =  this.activeStoryIndex - 1;
        this.userStorySer.currentStoryUuid = this.userStorySer.storyThumbnail[this.userStorySer.currentStoryIndex].uuid;
        this.storyStateManage(this.userStorySer.currentStoryUuid,this.activeStoryIndex, true );
      }
    }
    if (this.userStorySer.currentStoryIndex >=0) {
      this.customOptionsForStoriesList.startPosition = this.userStorySer.currentStoryIndex;
    }
  }


  /**
   * stories redirection
   */
async onCtaClick(event: any): Promise<void> {
    document.getElementsByTagName('BODY')[0].classList.remove('overflow-hidden','position-fixed');
    if (event.target.ctaType ===CTA_TYPE.PRIMARY && event.target.type !== STORY_TYPES.TEMPLATE) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY, event.repostingData.storyCode, SCREEN_NAME.STORY_PLAY, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.STORY_CTA, null )
    }
    if (event.target?.type === CTA_TYPE_ACTION.DEEPLINK || event.target?.type === CTA_TYPE_ACTION.REPOST) {
      if (event.target?.type === CTA_TYPE_ACTION.DEEPLINK) {
        window.location.href = event.target.url;
      }
      else if (event.target?.type === CTA_TYPE_ACTION.REPOST) {
        this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY, event.repostingData.storyCode, SCREEN_NAME.STORY_PLAY, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_STORY, null )
        if (this.dss.user_profile_data.profile.permission != 'all') {
          this.funCollectionService.assignAssociation('');
          this.closeStories();
          return;
        }
        this.dss.storyDuration = event.repostingData.duration;
        this.dss.story_creating_type = STORY_CREATION_TYPE.REPOST_STORY;
        this.dss.StoryFileType = event.repostingData.fileType;
        this.dss.storyRepostCta = event.repostingData.cta;
        if (event.repostingData.storyType === STORY_TYPES.PHARMA || event.repostingData.storyType === STORY_TYPES.PHARMAREPOST) {
          this.dss.storyType = CREATE_STORY_TYPES.PHARMAREPOST;
          this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
          this.dss.storyRepostCode = event.repostingData.storyType === STORY_TYPES.PHARMA ? event.repostingData.storyCode : event.repostingData.pharmaRepostStoryCode;
        }
        else if (event.repostingData.storyType === STORY_TYPES.TEMPLATE) {
          this.dss.storyType = STORY_TYPES.TEMPLATE;
          this.dss.templateRepost = true;
          this.dss.templateValue = event.repostingData.templateValue;
        }
        else {
          this.dss.storyType = CREATE_STORY_TYPES.REPOST;
          this.dss.user_story_productType = event.repostingData.productType;
          this.dss.user_story_productTypeId = event.repostingData.productTypeId;
          this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
        }
        if (event.repostingData.fileCode) {
          this.dss.story_reposting_fileCode.next(event.repostingData.fileCode);
        }
        this.closeStories();
        this.dss.create_Story.next(true);
      }
    }
    else if (event.target.type === STORY_TYPES.TEMPLATE) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY, event.repostingData.storyCode, SCREEN_NAME.STORY_PLAY, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.TEMPLATE_SELECTION, null )
      if (this.dss.user_profile_data.profile.permission != 'all') {
        this.funCollectionService.assignAssociation('');
        this.closeStories();
        return;
      }
      this.dss.story_template_code.next(event.target?.id);
      this.userStorySer.StoryshowLoader.next(false);
      this.dss.StoryFileType = STORY_TYPES.IMAGE;
      this.subscriptions.add(this.gerSer.getTemplateList(event.target?.id).subscribe(async data => {
        if (data?.lc) {
          this.dss.templateList.next(data.lc);
          for (const elem of data.lc) {
            this.userStorySer.fileCodeUrlMap.set(elem.code, elem.fileUrl);
          }
          this.dss.create_Template_type = (TEMPLATE_TYPE.TEMPLATE);
          this.dss.storyType = CREATE_STORY_TYPES.TEMPLATE;
          this.dss.templateValue = event.target?.id;
          this.userStorySer.StoryshowLoader.next(false);
          this.closeStories();
          this.dss.create_Story.next(true);
          if (event.repostingData.fileCode) {
            //  no code
          }
        }
      }));

    }
    return;
  }
  /**
   * profile header redirection
   */
  headerRedirection(event): void {
    if (event.userType ===STORY_TYPES.PHARMA) {
      this.funCollectionService.navigateToChannelDetail(event.targetId);
    }
    else {
      this.funCollectionService.navigateToUserProfie(event.targetId);
    }
    this.closeStories();
  }

  /**
   * deeplink redirection
   */
  deeplinkRedirection(event): void {

    // no code
  }

  async  fetchVideoAsBlob(videoUrl: string): Promise<Blob> {
    const response = await fetch(videoUrl);
    const videoData = await response.blob();
    return videoData;
  }
  /**
   * open new story
   */
  openStory(uuid: string, index:number): void {
    const extraInfo: extra = {key: 'UUID',  value: uuid};
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,0, this.funCollectionService.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.STORY, null, new Date().getTime(),[extraInfo] )
    this.userStorySer.currentStoryUuid = uuid;
    this.userStorySer.currentStoryIndex = index;
    this.activeStoryIndex = index;
    this.userStorySer.storyLoadingState.set(uuid, STORY_LOADING_STATE.PENDING);
    this.storyStateManage(uuid, index, false);
    this.isStoriesOpen = true;
    document.getElementsByTagName('BODY')[0].classList.add('overflow-hidden','position-fixed');
    this.userStoryCurrentTime = this.getTimeString();
  }

  onLastStory(): void {
    if (this.owlItem.carouselService.current() === this.owlItem.carouselService.maximum()) {
      this.closeStories();
    }
  }
  isStoriesAvailable(story): boolean {
    let apiRes = false;
    let realTime = false;
    if (story.viewed === 0){
      apiRes = true;
    }
    let key = '';
    if(story.type === STORY_TYPES.PHARMA) {
      key = 'channel' + story.channelId;
    }
    else {
      key = story.uuid;
    }
    realTime = !this.userStorySer.isAllStoryViewed(key);
    return apiRes && realTime;
  }
  /**
   * call story detail and store in service
   */
  storyStateManage(uuid,index: number, storyOpen: boolean): void {
    if (uuid && (!this.userStorySer.UserStoryDetail.has(uuid) || this.userStorySer.UserStoryDetail.get(uuid)?.expired === true )) {
      this.userStorySer.storyLoadingState.set(uuid, STORY_LOADING_STATE.PENDING);
      this.userStorySer.UserStoryDetail.set(uuid, '');
      this.subscriptions.add(this.gerSer.getUserStoryDetail('1',uuid).subscribe(async data => {
        if (data?.lc) {
          const imageUrl = [];
          for (const i in data.lc?.list) {
            if (data.lc?.list[i].fileType === STORY_TYPES.IMAGE) {
              imageUrl.push(data.lc?.list[i].fileUrl);
            }
            this.userStorySer.fileCodeUrlMap.set(data.lc?.list[i].fileCode, data.lc?.list[i].fileUrl);
            data.lc.list[i].duration = STORY_DEFAULT_DURATION;
          }
          this.userStorySer.preloadImages(imageUrl);
          const dataValue = {value: data.lc, expired: false};
          if (data.lc.type === STORY_TYPES.PHARMA) {
            this.userStorySer.storyLoadingState.set('channel' + data.lc.channelId, STORY_LOADING_STATE.SUCCESS);
            this.userStorySer.UserStoryDetail.set('channel'+ data.lc.channelId, dataValue);
          }
          this.userStorySer.storyLoadingState.set(uuid, STORY_LOADING_STATE.SUCCESS);
          this.userStorySer.UserStoryDetail.set(uuid, dataValue);
          this.userStorySer.storyDataChanged.next(2);
        }
      }));
    }
    //get next story detail
    if (index + 1 < this.userStorySer.storyThumbnail.length && this.userStorySer.storyThumbnail[index+1].uuid ) {
      const nextUuid = this.userStorySer.storyThumbnail[index+1].uuid;
      if (nextUuid && (!this.userStorySer.UserStoryDetail.has(nextUuid) ||  this.userStorySer.UserStoryDetail.get(nextUuid)?.expired === true)) {
        this.userStorySer.storyLoadingState.set(nextUuid, STORY_LOADING_STATE.PENDING);
        this.userStorySer.UserStoryDetail.set(nextUuid, '');
        this.subscriptions.add(this.gerSer.getUserStoryDetail('1', nextUuid).subscribe(async data => {
          if(data?.lc) {
            const imageUrl = [];
            for (const i in data.lc?.list) {
              if (data.lc?.list[i].fileType === STORY_TYPES.IMAGE) {
                imageUrl.push(data.lc?.list[i].fileUrl);
              }
              this.userStorySer.fileCodeUrlMap.set(data.lc?.list[i].fileCode, data.lc?.list[i].fileUrl);
              data.lc.list[i].duration = STORY_DEFAULT_DURATION;
            }
            this.userStorySer.preloadImages(imageUrl);
            const dataValue = {value: data.lc, expired: false};
            if (data.lc.type === STORY_TYPES.PHARMA) {
              this.userStorySer.storyLoadingState.set('channel' + data.lc.channelId, STORY_LOADING_STATE.SUCCESS);
              this.userStorySer.UserStoryDetail.set('channel' + data.lc.channelId, dataValue);
            }
            this.userStorySer.storyLoadingState.set(nextUuid, STORY_LOADING_STATE.SUCCESS);
            this.userStorySer.UserStoryDetail.set(nextUuid,dataValue);
            this.userStorySer.storyDataChanged.next(2);
          }
        }));
      }
    }
    //get previous story detail
    if ((index - 1) >= 0 && this.userStorySer.storyThumbnail[index-1].uuid ) {
      const previousUuid = this.userStorySer.storyThumbnail[index-1].uuid;
      if (previousUuid && (!this.userStorySer.UserStoryDetail.has(previousUuid) || this.userStorySer.UserStoryDetail.get(previousUuid)?.expired === true)) {
        this.userStorySer.storyLoadingState.set(previousUuid, STORY_LOADING_STATE.PENDING);
        this.userStorySer.UserStoryDetail.set(previousUuid,  '');
        this.subscriptions.add(this.gerSer.getUserStoryDetail('1', previousUuid).subscribe(async data => {
          if(data.lc) {
            const imageUrl = [];
            for (const i in data.lc?.list) {
              if (data.lc?.list[i].fileType === STORY_TYPES.IMAGE) {
                imageUrl.push(data.lc?.list[i].fileUrl);
              }
              this.userStorySer.fileCodeUrlMap.set(data.lc?.list[i].fileCode, data.lc?.list[i].fileUrl);
              data.lc.list[i].duration = STORY_DEFAULT_DURATION;
            }
            this.userStorySer.preloadImages(imageUrl);
            this.userStorySer.storyLoadingState.set(previousUuid, STORY_LOADING_STATE.SUCCESS);
            const dataValue = {value: data.lc, expired: false};
            if (data.lc.type === STORY_TYPES.PHARMA) {
              this.userStorySer.storyLoadingState.set('channel' + data.lc.channelId, STORY_LOADING_STATE.SUCCESS);
              this.userStorySer.UserStoryDetail.set('channel'+ data.lc.channelId, dataValue);
            }
            this.userStorySer.UserStoryDetail.set(previousUuid, dataValue);
            this.userStorySer.storyDataChanged.next(2);
          }
        }));
      }
    }
  }

  onStoryDelete(event: any): void {
    // no
  }

  closeStories(): void {
    this.isStoriesOpen = false;
    this.dss.viewListByDefault = false;
    this.userStorySer.resetStoryView();
    document.getElementsByTagName('BODY')[0].classList.remove('overflow-hidden', 'position-fixed');
  }
  checkForPrevOffset(): void {
    if (this.prevOffset !== this.storyListOffset) {

      this.prevOffset = this.storyListOffset;

      this.getUserStoryList();

    }

  }
  getStoryList(data: SlidesOutputData) { // <- method that listens to the event `translated`
    if (data.startPosition > 0 && data.startPosition >= this.userStoryList.length - 5 && this.storyListOffset > 0) {  // <- THE MOMENT TO ADD DATA
      this.customOptionsForStoriesList.startPosition = data.startPosition;
      this.checkForPrevOffset();
    }
  }
  /**
   * returns carowsel option for hcf
   */
  hcfContinueWatchOption(drawPattern: string): OwlOptions {
    if (drawPattern === NUMBERS.FIVE.toString()) {
      return this.hcfContinueWatchOpt;
    }
    else {
      return this.hcfOptions;
    }
  }
  /**
   * gets play time in minute
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hcfPlayTime(playTime: any): string {
    return (playTime !== 0 ? this.funCollectionService.secondToHoursMinutesSeconds(playTime) : '');
  }
  /**
   * Redirect to the validate target for hcf whole card.
   */
  hcfCardTarget(cardTarget: Target, hcfInfo, connectionId): void {
    const productType = hcfInfo.product_type;
    const productId = hcfInfo.product_id;
    if (connectionId === HCF_CONNECTION_ID.CONTINUE_WATCH) {
      this.sendAnalytics(EVENT_NAME.CONTINUE_WATCH_CLICK, productType, productId, SCREEN_NAME.GRAND_ROUND);
    }
    /**
    * //TODO setting variable for webinar continue watch when user is coming from HCF
    */
    if (productType === PRODUCT_TYPE_CONSTANT.WEBINAR) {
      this.dqVideoPlayerService.webinarContinueWatchResumeTime = hcfInfo?.info?.time?.watch;
    }
    this.sendAnalytics(EVENT_NAME.HCF_IN_PRODUCT_CARD_CLICK, productType, productId, SCREEN_NAME.HORIZONTAL_CAROUSEL_SCREEN);
    this.funCollectionService.validateTargetType(cardTarget, +productId, this.loginUserCustomeId);
  }

  /**
   * Redirect to the validate target for hcf card button.
   */
  hcfCtaTarget(target: Target, hcfInfo): void {
    const productType = hcfInfo.product_type;
    const productId = hcfInfo.product_id;
    this.sendAnalytics(EVENT_NAME.GET_STARTED_CLICK, productType, productId, SCREEN_NAME.HORIZONTAL_CAROUSEL_SCREEN);
    if (productType === PRODUCT_TYPE_CONSTANT.CONNECTION) {
      this.sendConnectionRequest(target.url ? target.url : target.id, hcfInfo);
    } else {
      this.funCollectionService.validateTargetType(target, productId);
    }
  }
  /**
   * function to get pvs
   */
  getPromoViewStrip(): void {
    this.subscriptions.add(this.gerSer.getPromoViewStrip().subscribe(data => {
      if (data.data) {
        this.pvsData = data.data;
        this.pvsHtml = this.domSanitize.bypassSecurityTrustHtml(this.pvsData.content);
        if (this.pvsData.pvs_id && sessionStorage.getItem('pvsCrossed' + this.pvsData.pvs_id)) {
          this.pvsFlag = false;
        }
        else {
          this.pvsFlag = true;
        }
        if (this.pvsData.pvs_id) {
          this.render = true;
        }
      }
    }));
  }
  /**
   * function to close pvs
   */
  closePPs(): void {
    this.render = false;
  }
  /**
  /**
   * Send Connection Request.
   */
  sendConnectionRequest(requesteeId, feedList): void {
    this.postSer.userConnection(CONNECTION_STATUS.ADD.ACTION, requesteeId, CONNECTION_STATUS.ADD.ACTION_TYPE)
      .subscribe((res) => {
        if (res.code === NUMBERS.TWO_THOUSAND && res.status === NUMBERS.ONE) {
          feedList.info.target['disabled'] = true;
          feedList.info.target.text = this.mls.languageText.connection_list.key4;
          this.funCollectionService.showSuccess(res.msg, 'Success');
        } else {
          feedList.info.target.enabled = NUMBERS.ZERO.toString();
          this.funCollectionService.errorHandeler(res);
        }
      });
  }

  /**
   * Redirect to the validate target for hcf outer card button.
   */
  hcfOuterCtaTarget(target: Target, productType: number, productTypeId: number): void {
    this.sendAnalytics(EVENT_NAME.GET_STARTED_CLICK, productType, productTypeId, SCREEN_NAME.HORIZONTAL_CAROUSEL_SCREEN);
    if (productTypeId === HCF_CONNECTION_ID.CONTINUE_WATCH) {
      this.sendAnalytics(EVENT_NAME.CONTINUE_WATCH_VIEWALL_CLICK, NUMBERS.ZERO, NUMBERS.ZERO, SCREEN_NAME.CONTINUE_WATCH_VIEWALL);
      this.router.navigateByUrl('/web/viewAll');
      return;
    }
    this.funCollectionService.validateTargetType(target, productTypeId);
  }

  /**
   * Redirect to the validate target for hcf outer card button.
   */
  hcfOuterCardTarget(productType: number, productTypeId: number): void {
    this.sendAnalytics(EVENT_NAME.HCF_CLICK, productType, productTypeId, SCREEN_NAME.GRAND_ROUND);
  }

  /**
   * Send analytics event.
   */
  sendAnalytics(eventName: EventDataKey, productType: number, productTypeId: number, screenName: string, startTime = this.getTimeString(), endTime = this.getTimeString()): void {
    this.analyticsData = {
      event_name: eventName,
      product_type: productType,
      product_type_id: productTypeId,
      screen_name: screenName,
      start_time: startTime,
      end_time: endTime
    };
  }

  /**
   * Get the current time in string.
   */
  getTimeString(): string {
    return new Date().getTime().toString();
  }

  /**
   * This method toggles the isInviteCodeModalShown flag.
   * Show Invite Modal when state is true (Notification is for Invite Code)
   * Hide Invite Modal on closing invite code popup.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  toggleInviteModal(state: boolean): void {
    // this.isInviteCodeModalShown = state;
  }

}


